import React, {Component} from 'react';
import omit from 'object.omit'
import {
  DropdownButton,
  MenuItem,
  Grid,
  Row,
  Col,
  Thumbnail,
  Button,
  FormGroup,
  HelpBlock,
  ControlLabel,
  FormControl,
  ProgressBar
} from "react-bootstrap";
import clone from 'fast-clone'
import unique from 'array-unique'
import sortOn from 'sort-on'
import ReactHeight from 'react-height'
import ReactGA from 'react-ga';
import Solution from './Solution.js';
import Step from './Step.js';
import Header from './Header.js';
import isString from 'lodash.isstring'

const IE_MAX_LENGTH_URL = 2083

// Get the localization from the global scope
let text = window.text;

const idUtstickVal = "uv_";
const idUtstick = "utstick";

export const getURLParameter = (name) => {
  const found = decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20'))
  return found !== 'null' ? found : null
}

/// Round to 1st digital
let round_near = function(val){
  let out = Math.round(val*1e5)/1e5;
  if (out == 0 || !isFinite(out)){
    return ""
  }
  return out
}

const getUrl = () => `${location.protocol}//${location.host}${location.pathname}`

const Loading = () => {
  return (
    <div className='page-loader'>
    <ProgressBar active now={45} />
    <p className='text-muted'>{text.loadingLayout}</p>
    </div>
  )
}

class Main extends Component {
  familyList = []
  profileList = []
  treatmentList = []
  surfaceList = []

  constructor(props, context) {
    super(props, context);
    // Set an inital state
    this.state = {
      type: 0,  // The selected roof
      family: null,  // The selected plate family
      plate: null, // The selected plate
      surface: null, // The selected surface treatment
      pickerProfile: null,
      pickerTreatment: null,
      pickerSurface: null,
      pickerFamily: null,
      pickerPlate: null,
      step: 1,  // Which step in the gui the user is currently viewing
      user: undefined, // Undefined if no logged in user
      prices: {}, // Should be the empty object when the user is not logged in
      rabatt: [], // The discount that should be shown,
      selectedProductOptions: [],
      sol: null,
      solLoading: false
    }
  }
  onChangeHeight = (height) => {
    global.parent.postMessage({height}, '*')
  }
  // Allow us to read out a get parameter from the URL

  componentWillMount () {
    const s = getURLParameter('s')
    if (s !== undefined && s !== null && s !== '') {
      const appState = JSON.parse(s)
      const solLoading = appState && appState.step && appState.step > 4 ? true : false
      this.setState({rabatt: [], ...appState, solLoading})
    }
    const lang = getURLParameter('lang')
    if (lang) {
      text.setLanguage(lang)
      global.lang = lang
    }
  }

  componentDidMount () {
    var currentUser = this.props.Parse.User.current()
    if (currentUser) {
      this.setState({user: currentUser})
    } else {
      this.setState({user: undefined})
    }
    window.setTimeout(() => this.updatePrices(), 0)
    if (this.state.step > 4) {
      this.runOptimize()
    }
  }

  onChangeLanguage = (lang) => {
    global.location = `${getUrl()}${this.getStateUrl(lang)}`
    ReactGA.event({
      category: 'Navigation',
      action: 'Change Language',
      value: lang,
      label: 'Lang ' + lang
    });
  }

  getLanguage () {
    return getURLParameter('lang') || 'no'
  }

  getLanguagesRaw () {
    return getURLParameter('languages') || 'no|en'
  }

  getLanguages () {
    return this.getLanguagesRaw().split('|')
  }

  componentWillUpdate (nextProps, nextState) {
    // this.componentWillUpdateStep4(nextProps, nextState)
    this.componentWillUpdateProductOptions(nextProps, nextState)
    if (nextState.step > 4 && this.state.step < 5) {
      this.runOptimize()
    }
  }

  /// Parses a string to a number equivalent, i.e. allowing for ',' etc.
  /// Returned value is still a string
  parseTextNumber(str){
    if (isString(str) && str.includes(',')){
      return str.replace(/,/g, '.');
    }
    return str;
  }

  componentDidUpdate (prevProps, prevState) {
    const stateUrl = `${getUrl()}${this.getStateUrl()}`
    if (stateUrl.length > IE_MAX_LENGTH_URL) {
      console.warn('Max-length url in IE reached')
    }
    global.history.pushState({}, 'Roof optimization', stateUrl);

    let plate = this.getplate().plate
    if (prevState.plate !== null && plate === null) {
      this.setState({
        plate: plate
      })
    }
    else if (this.state.step == 4 && plate instanceof Object && (prevState.plate == null || prevState.plate.nobb[0] !== plate.nobb[0])){
      this.setState({
        plate: plate
      })
    }
    if(prevState.pickerFamily !== this.state.pickerFamily && this.profileList.length == 1) {
      this.setState({
        pickerProfile: this.profileList[0].name
      })
    }
    if(prevState.pickerProfile !== this.state.pickerProfile && this.treatmentList.length == 1) {
      this.setState({
        pickerTreatment: this.treatmentList[0].name
      })
    }
    if(prevState.pickerTreatment !== this.state.pickerTreatment && this.surfaceList.length == 1) {
      this.setState({
        pickerSurface: this.surfaceList[0].name
      })
    }
  }

  getStateUrl (lang) {
    const state = omit(this.state, ['selectedProductOptions', 'user', 'sol'])
    const appState = ''; // JSON.stringify(state)
    return `?s=${encodeURIComponent(appState)}&lang=${lang || getURLParameter('lang')}&languages=${this.getLanguagesRaw()}&country=${getURLParameter('country')}`
  }

  getSelectedRoof () {
    const {layout: {names}} = this.props
    const {type} = this.state
    return names.find((name, i) => i === type)
  }

  runOptimize () {
    this.setState({
      solLoading: true
    }, () => {
      setTimeout(() => {
        const {layout: {types, utstickTypes}} = this.props
        const selected = this.getSelectedRoof()
        let {calcplate} = this.getplate()
        const selectedRoof = types[selected]
        const selectedRoofObject = (new selectedRoof())
        const rf = {}
        selectedRoofObject.inputs.forEach((input, i) => {
          rf[input.name] = this.state[`val_${input.name}`]
        })
        const roof = {
          type: selected,
          roof: rf,
          category:'roofs'
        }
        const utstickState = this.state[idUtstick]
        const utsticks = this.state.selectedUtstickTypes.reduce((list, utstickName, i) => {
          const utstick = utstickTypes[utstickName]
          const utstickObject = new utstick()
          const utstickProps = {}
          utstickObject.inputs.forEach((utstickInput, j) => {
            utstickProps[utstickInput.name] = utstickState[`${idUtstickVal}${i}_${j}${utstickInput.name}`]
          })
          return [
            ...list,
            {
              type: utstickName,
              roof: utstickProps,
              category: 'utsticks'
            }
          ]
        }, [])

        const sol = this.props.layout.optimize([roof, ...utsticks], calcplate)
        this.defaultProductOption(sol)
        this.setState({
          sol,
          solLoading: false,
          selectedProductOptions: this.state.selectedProductOptions.length === 0 ? [
          ] : this.state.selectedProductOptions
        })
      }, 50)
    })
  }

  defaultProductOption(sol) {
    const {type} = this.state;

    const totalArea = sol && sol.area ? sol.area / 1e1 : null
    const mone = sol && sol.mone || null;
    const gradeGutter = sol && sol.gradeGutter || null;
    const vindski = sol && sol.vindski || null;
    var pipelength = (sol && sol.pipes || []).reduce( (total, num) => (total + Number(num || 0)), 0);
    const {productOptions, roofTypes} = this.props
    const {calcplate: selectedPlate} = this.getplate(this.props, this.state)
    const selectedRoofType = roofTypes[type];
    const availableProductOptions = selectedPlate
                                 && selectedPlate.products
                                 && selectedRoofType
                                 && selectedRoofType.NOBB
                                  ? productOptions
                                    .filter(({nobb}) =>
                                      !!selectedRoofType.NOBB.find(val => val === nobb))
                                    .filter(({nobb}) => !!selectedPlate.products.find(val => val.nobb === nobb)) : [];

    const selectedProductOptions = availableProductOptions.map(({name, nobb, image, category}) => {
      const defaultPrice = selectedPlate.products && selectedPlate.products.find(item => item.nobb === nobb);
      const defaultItems = defaultPrice && defaultPrice.number && isFinite(defaultPrice.number(totalArea, mone, vindski, pipelength, gradeGutter)) ?
                           Math.ceil(defaultPrice.number(totalArea, mone, vindski, pipelength, gradeGutter)) : 0;
      const defaultSelected = selectedRoofType.DefaultAddons.indexOf(nobb) > -1;
      return {
        nobb,
        name,
        image,
        category,
        items: defaultItems,
        selected: true,
        defaultSelected: true,
        defaultItems: defaultItems
      };
    }).sort((a, b) => {
      if(a.name < b.name) return -1;
      if(a.name > b.name) return 1;
      return 0;
    });

    this.setState({selectedProductOptions});
  }

  // Translate the react state to a plate object that can be used towards
  // the calculation back-end
  getplate() {

    const selectedFamily = this.props.layout.families[this.state.pickerFamily];

    const selectedProfile = selectedFamily ? selectedFamily.filter(
      it => it.profile.trim() === this.state.pickerProfile
    ) : null;

    const selectedThickness = selectedProfile ? selectedProfile.filter(
      it => it.treatment.trim() === this.state.pickerTreatment
    ) : null;

    const selectedColor = selectedThickness ? selectedThickness.filter(
      it => it.surface.trim() === this.state.pickerSurface
    ) : null;

    let plate = selectedColor && selectedColor.length > 0 ? selectedColor[0] : null;

    if (plate) {
      // Get the height based on state - but clip it into the allowable for this plate
      let height = this.state.height*1;
      if(!isFinite(height))
      height = 2000
      if(plate && plate.height.type == "variable") {
        if(height < plate.height.min*1000)
        height = plate.height.min*1000
        if(height > plate.height.max*1000)
        height = plate.height.max*1000
      }
    }

    return {
      calcplate: plate,
      plate: plate
      // families: fams,
      // plates: platenames,
      // surfaces: surfaces,
      // height: height,
      // f: f,
      // p: p,
      // s: s,
    }
  }

  /// Returns map of the ins (key) and their respective stored state values (value)
  getRoofValues(ins) {
    let ret = {}
    for(let i = 0; i < ins.length; i++){
      ret[ins[i].name] = this.state["val_" + ins[i].name];
    }
    return ret;
  }
  // Different state id for utstikks: Get all values as a map for this utstikk
  getUtstikkValues(ins,j) {
    let ret = {}
    for(let i = 0; i < ins.length; i++){
      ret[ins[i].name] = this.state[idUtstick][idUtstickVal+j+"_"+i + ins[i].name];
    }
    return ret;
  }

  /// Make the text values for alternatives nice looking
  alternativesTextValue(rawValue, convertedValue){
    if (rawValue == undefined){
      return ""
    }
    // Append dot to displayed value if the same as entered
    let val = convertedValue
    let valStr = val + ""
    let appendDot = false
    if (isString(rawValue)){
      appendDot = rawValue.slice(-1) == "." ? true : false;
      if (valStr.slice(-1)=="."){
        appendDot = false;
      }
    }
    if (appendDot && val%1 === 0){
      val = val + "."
    }
    return val
  }

  /// converts from mm to m if applicable
  /// Note: Slight hack utilizing that everything is in mm execpt entries with name 'angle'
  /// Proper conversion could be implemented if time allos
  convertFromMm(value, property){
    if (isString(property) && property.indexOf("angle") !== -1){
      return value;
    }
    return value/1000.0;
  }
  /// converts from mm to m for applicable properties
  /// Note: Slight hack utilizing that everything is in mm execpt entries with name 'angle'
  /// Proper conversion could be implemented if time allos
  convertToMm(value, property){
    if (isString(property) && property.indexOf("angle") !== -1){
      return value;
    }
    return value*1000.0;
  }

  // Called whenver logging in or out to gather the price information from the
  // database if needed, once recieved the state is updated to force a re-load
  updatePrices() {
    if(this.state.user != undefined) {
      // So we should get the price information from the
      // database and add it to our state such that we can
      // display it.
      let t = this
      var price = this.props.Parse.Object.extend("Price");
      var query = new this.props.Parse.Query(price);
      query.limit(1000)
      query.find({
        success: function(results) {
          var res = {}
          for (var i = 0; i < results.length; i++) {
            var object = results[i];
            let p = object.get("price")
            if(isFinite(p)) {
              res[object.get("nobb")] = () => 1*p
            } else {
              res[object.get("nobb")] = new Function("height", "length", '"use strict";return '+p)
            }
          }
          t.setState({prices: res})
        },
        error: function(error) {
          this.setState({prices: {}})
        }
      });
    } else {
      this.setState({prices: {}})
    }
  }

  // Callback for when user presses the move buttons
  move(back) {
    let step = this.state.step
    if(back)
      step--
               else
                 step++
               if(step < 1)
                 step = 1;
    if(step > 6)
      step = 6;
    this.setState({step: step});

    ReactGA.event({
      category: 'Navigation',
      action: 'Step',
      value: step,
      label: 'Step ' + step
    });

  }

  setRoofType(i) {
    const {roofTypes} = this.props
    const selectedRoofType = roofTypes[i];

    this.setState({
      type: i,
      step:2,
      stepVisited: 2
    });
  }

  render() {
    let layout = this.props.layout;
    // We take the slighty unusuall way of calculating everything for all stages
    // in this render method and let the Step components hide/show themselves instead

    // Since we use it several times
    let move = (back) => this.move(back)
    // Build the list with roof types
    let types = [];
    const selected = this.getSelectedRoof()
    for(let i = 0; i < layout.names.length; i++) {
      let name = layout.names[i];
      let roofo = new this.props.layout.types[name]();
      let o = (
        <Col key={i} xs={6} md={4}>
          <Thumbnail
            className={ i == this.state.type ? "thumbnailselect" : ""}
            src={"roofs/"+name+".png"} alt="roof "
            onClick={() => {
                this.setRoofType(i);
                this.setState({type: i, step:2})
                ReactGA.event({
                  category: 'Select',
                  action: 'Roof Select',
                  label: 'Type ' + i
                });
                ReactGA.event({
                  category: 'Navigation',
                  action: 'Step',
                  value: 2,
                  label: 'Step ' + 2
                });
            }}
          >
            <h3>{roofo.name}</h3>
            <p>{roofo.description}</p>
          </Thumbnail>
        </Col>
      )
      types.push(o)
    }

    // Based on the selected roof type we show the inputs that are relevant
    let inputerror = false;
    let inputs = [];
    let roof = this.props.layout.types[selected];
    let roofo = (new roof())
    let ins = roofo.inputs

    let inputobjs = [];
    let roofinputs = {}
    for(let i = 0; i < ins.length; i++) {
      let j = i;
      let vv = this.state["val_" + ins[i].name];
      let hb = null
      // Only check for errors if at current step
      if (this.state.step == 2){
        vv = this.parseTextNumber(vv);
        if(!isFinite(vv)) {
          hb = (<HelpBlock>{text.errNotANumber}</HelpBlock>)
          inputerror = true;
        } else if(vv <= 0) {
          hb = (<HelpBlock>{text.errLowerLim + 0}</HelpBlock>)
          inputerror = true;
        } else if(vv >5e5) {
          hb = (<HelpBlock>{text.errUpperLim + 5000000+""}</HelpBlock>)
          inputerror = true;
        }
      }
      let obj = {
        name: ins[i].name,
        vv: vv,
        hb: hb,
      }
      inputobjs.push(obj)
      roofinputs[ins[i].name] = vv;
    }

    if (this.state.step == 2){
      if (!inputerror){
        // Validate the input data
        let insErr = roofo.validateInput(roofinputs)
        if (insErr !== undefined){
          for (let i = 0; i < inputobjs.length; i++){
            if (insErr[inputobjs[i].name] !== undefined){
              inputobjs[i].hb = (<HelpBlock>{insErr[inputobjs[i].name]}</HelpBlock>)
              inputerror = true;
            }
          }
        }
      }
    }

    for (let i = 0; i < inputobjs.length; ++i){
      let obj = inputobjs[i]
      let validstate = obj.hb == null ? "success" : "error";
      if (ins[i].alternatives !== undefined){
        let alts = ins[i].alternatives

        let list = [];
        // Push original item
        list.push(ins[i].name);
        if(this.state["btn_"+list[0]] === undefined || this.state["btn_"+list[0]] == ""){
          let o = {}
          o["btn_"+list[0]] = 'angle';
          this.setState(o);
        }
        // Push alternatives
        list = list.concat(alts.names);

        let items = [];
        for (let j = 0; j < list.length; j++){
          items.push(
            <MenuItem key={j} eventKey={j}>
            {
              text[list[j]]
            }
            </MenuItem>
          )
        }
        let values = this.getRoofValues(ins);
        inputs.push(
          <FormGroup key={i} controlId={"_" + i} validationState={validstate}>
          <ControlLabel>{String.fromCharCode(65+i)}: </ControlLabel>

          <DropdownButton tabIndex={-1} bsStyle="default" title={
            text[this.state["btn_"+list[0]]]
          } key={0} id="dropdown-basic"
          onSelect={(eventKey, event) => {
            let title = list[eventKey];
            let o = {};
            o["btn_"+list[0]] = title;
            this.setState(o);
          }
          } >
          {
            items
          }
          </DropdownButton>
          <FormControl
          type="number"
          autoFocus={i==0}
          onChange={(e)=> {
            let o = {};
            let val = this.convertFromMm(this.parseTextNumber(e.target.value), this.state["btn_"+list[0]]);

            let values_scoped = this.getRoofValues(ins)
            val = alts.convertFrom(this.state["btn_"+list[0]], val, values_scoped) // Convert from current input alternative to the stored one
            o["val_" + ins[i].name] = val
            this.setState(o)
          }}
          value={
            this.convertToMm(
              this.alternativesTextValue(obj.vv, round_near(alts.convertTo(this.state["btn_"+list[0]], obj.vv, values))),
              this.state["btn_"+list[0]])
          }
          />
          {obj.hb}
          </FormGroup>
        )
      } else{
        inputs.push(
          <FormGroup key={i} controlId={"_" + i} validationState={validstate}>
          <ControlLabel>{String.fromCharCode(65+i)}: <span style={{fontWeight: 400}}>{ins[i].title}</span></ControlLabel>
          <FormControl
          type="number"
          autoFocus={i==0}
          onChange={(e)=> {
            let o = {};
            o["val_" + ins[i].name] = this.parseTextNumber(e.target.value)/1000;
            this.setState(o)
          }}
          value={obj.vv == undefined ? "" : obj.vv*1000} />
          {obj.hb}
          </FormGroup>
        )
      }
    }

    // Build the list of 'utstick' types
    let utstickTypes = []; // Roofs to choose from by the user
    if (this.state.selectedUtstickTypes === undefined){
      this.state.selectedUtstickTypes = [];
    }

    // Get selected utsticks
    for (let j = 0; j < this.state.selectedUtstickTypes.length; j++){
      utstickTypes.push([]);
      // Build list of utstick types
      for(let i = 0; i < layout.utstickNames.length; i++) {
        let name = layout.utstickNames[i];

        let utsticko = new this.props.layout.utstickTypes[name]();
        let utstickelem = (
          <Col key={i} xs={6} md={4}>
          <Thumbnail
          className={ name == this.state.selectedUtstickTypes[j] ? "thumbnailselect" : ""}
          src={"utsticks/"+name+".png"} alt="utstick "
          onClick={() => {
            this.state.selectedUtstickTypes[j] = name;
            this.setState({selectedUtstickTypes: this.state.selectedUtstickTypes})

            ReactGA.event({
              category: 'Select',
              action: 'Utsticks ',
              label: 'Type ' + this.state.selectedUtstickTypes.join(",")
            });
          }}
          >
          <h3>{utsticko.name}</h3>
          <p>{utsticko.description}</p>

          </Thumbnail>
          </Col>
        )
        utstickTypes[j].push(utstickelem)
      }
    }

    // Based on the selected utsticks we show the inputs that are relevant
    let utstickos = []
    let utstickInputs = []
    let utstickIns = [];
    let count = 0;
    if (this.state[idUtstick] == undefined){
      this.state[idUtstick] = {};
    }

    let utstickerror = false
    for (let jj = 0; jj < this.state.selectedUtstickTypes.length; jj++){
      let j = jj;
      utstickInputs.push([]);
      let name = this.state.selectedUtstickTypes[j]
      let utstick = this.props.layout.utstickTypes[name];

      utstickos.push((new utstick()));
      utstickIns.push(utstickos[j].inputs);

      let inputobjs = [];
      let roofinputs = {}
      let utstickIn = utstickIns[j];
      for(let ii = 0; ii < utstickIn.length; ii++) {
        let i = ii;

        let vv = this.state[idUtstick][idUtstickVal+j+"_"+i + utstickIn[i].name];
        // Check the input and errors state.
        let hb = null
        // Only check for errors if at current step
        if (this.state.step == 3){
	        vv = this.parseTextNumber(vv)
          if (utstickIn[ii].validate) {
            if (!utstickIn[ii].validate(vv)) {
              hb = (<HelpBlock>{text.errDidNotValidate}</HelpBlock>)
              utstickerror = true;
            }
          } else {
            if(!isFinite(vv)) {
              hb = (<HelpBlock>{text.errNotANumber}</HelpBlock>)
              utstickerror = true;
            } else if(vv <= 0) {
              hb = (<HelpBlock>{text.errLowerLim + 0}</HelpBlock>)
              utstickerror = true;
            } else if(vv > 5e5) {
              hb = (<HelpBlock>{text.errUpperLim + 500000+""}</HelpBlock>)
              utstickerror = true;
            }
          }
        }
        let obj = {
          name: utstickIn[i].name,
          vv: vv,
          hb: hb,
        }
        inputobjs.push(obj)
        roofinputs[utstickIn[i].name] = vv;
      }
      if (this.state.step == 3){
        if (!inputerror){
          // Validate the input data
          let insErr = utstickos[j].validateInput(roofinputs)
          if (insErr !== undefined){
            for (let i = 0; i < inputobjs.length; i++){
              if (insErr[inputobjs[i].name] !== undefined){
                inputobjs[i].hb = (<HelpBlock>{insErr[inputobjs[i].name]}</HelpBlock>)
                inputerror = true;
              }
            }
          }
        }
      }
      for (let i = 0; i < inputobjs.length; ++i){
        let obj = inputobjs[i]
        let validstate = obj.hb == null ? "success" : "error";

	      if (utstickIn[i].alternatives !== undefined){
          let alts = utstickIn[i].alternatives

          let list = [];
          // Push original item
          //idUtstickVal+j+"_"+i + utstickIn[i].name
          //idUtstickVal+j+"_"+i
          list.push(utstickIn[i].name);
          let stateidpre = "btn_"+jj+"_"
          if(this.state[stateidpre+list[0]] === undefined || this.state[stateidpre+list[0]] == ""){
            let o = {}
            o[stateidpre+list[0]] = 'angle';
            this.setState(o);
          }
          // Push alternatives
          for (const altname of alts.names){
            list.push(altname)
          }
          let items = [];
          for (let j = 0; j < list.length; j++){
            items.push(
              <MenuItem key={j} eventKey={j}>
              {
                text[list[j]]
              }
              </MenuItem>
            )
          }

          let values = this.getUtstikkValues(utstickIn, jj);
          utstickInputs[j].push(
            <FormGroup key={jj+"0"+i} controlId={"_" + jj+"_"+i} validationState={validstate}>
            <ControlLabel>{String.fromCharCode(65+i)}: </ControlLabel>
            <DropdownButton tabIndex={-1} bsStyle="default" title={
              text[this.state[stateidpre+list[0]]]
            } key={0} id="dropdown-basic"
            onSelect={(eventKey, event) => {
              let title = list[eventKey];
              let o = {};
              o[stateidpre+list[0]] = title;
              this.setState(o);
            }
            } >
            {
              items
            }
            </DropdownButton>
            <FormControl
            type="number"
            autoFocus={i==0}
            onChange={(e)=> {
              let val = this.convertFromMm(this.parseTextNumber(e.target.value, this.state[stateidpre+list[0]]), this.state[stateidpre+list[0]]);
              let values_scoped = this.getUtstikkValues(utstickIn, jj)
              val = alts.convertFrom(this.state[stateidpre+list[0]], val, values_scoped) // Convert from current input alternative to the stored one


              let o = clone(this.state[idUtstick]);
              o[idUtstickVal+j+"_"+i + utstickIn[i].name] = val;
              let s = {}
              s[idUtstick] = o
              this.setState(s);
            }}
            value={
              this.convertToMm(
                this.alternativesTextValue(obj.vv, round_near(alts.convertTo(this.state[stateidpre+list[0]], obj.vv, values))),
                this.state[stateidpre+list[0]]
              )
            } />
            {obj.hb}
            </FormGroup>
          )
        }else{
          utstickInputs[j].push(
            <FormGroup key={count} controlId={"_" + count} validationState={validstate}>
            <ControlLabel>{String.fromCharCode(65+i)}: <span style={{fontWeight: 400}}>{utstickIn[i].title}</span></ControlLabel>
            <FormControl
            type="number"
            autoFocus={i==0}
            onChange={(e)=> {
              let o = clone(this.state[idUtstick]);
              o[idUtstickVal+j+"_"+i + utstickIn[i].name] = e.target.value/1000;
              let s = {}
              s[idUtstick] = o
              this.setState(s);
            }}
            value={obj.vv == undefined ? "" : obj.vv*1000} />
            {obj.hb}
            </FormGroup>
          )
        }
        count++;
      }
    }

    // Create the list of utstick types
    let utss = layout.utstickNames.map((name, i) => {
      let utsticko = new this.props.layout.utstickTypes[name]();
      return (
        <Col key={i} xs={6} md={4}>
        <Thumbnail
        src={"utsticks/"+name+".png"} alt="utstick "
        onClick={() => {
          let newarr;
          if (this.state.selectedUtstickTypes === undefined){
            newarr = [];
          } else {
            newarr = this.state.selectedUtstickTypes.slice();
          }
          newarr.push(name);
          this.setState({selectedUtstickTypes:newarr})
          ReactGA.event({
            category: 'Select',
            action: 'Utsticks',
            label: 'Type ' + newarr.join(","),
            value: newarr.join(",")
          })
        }}
        >
        <h3>{utsticko.name}</h3>
        <p><Button className="add" bsStyle="default">{text.incl}</Button></p>
        </Thumbnail>
        </Col>
      )
    })

    // Create combined list to render
    let utstickRenders = [];
    for (let j = 0; j < this.state.selectedUtstickTypes.length; j++){
      utstickRenders.push(<div key={j} className="utsticks">
        <div>
        <h1 className="splitutstick">{text.input + utstickos[j].name + " (" + (1+j) + ")"}</h1>
        <Row>
        <Col sm={8} md={7}>
        <center>
        <img
        src={"utsticks/"+this.state.selectedUtstickTypes[j]+"_measure.png"} alt="utstick"  className="measures"
        />
        </center>
        </Col>
        <Col sm={6} md={5}>
        {utstickInputs[j]}
        </Col>
        </Row>
        </div>
        <div className="delete">
        <Button className="delete"
        onClick={
          () => {
            let newarr = this.state.selectedUtstickTypes.slice();
            newarr.splice(j,1);
            this.setState({selectedUtstickTypes:newarr})

            let o = clone(this.state[idUtstick]);
            if (o === undefined){
              throw "Could not find any utstick states even though an utstick will be deleted"
            }
            // Cleanup the state
            for (var key in o) {
              if (!o.hasOwnProperty(key)){
                continue;
              }
              let mstr = idUtstickVal+j;
              let sub = key.substring(0, mstr.length);
              if (sub == mstr){
                delete o[key];
              }
            }
            this.setState({idUtstick:o});
            ReactGA.event({
              category: 'Select',
              action: 'Remove Utstick',
              label: 'Type ' + o.join(","),
              value: o.join(",")
            })

          }
        }
        children={text.deleteAddon}
        />
        </div>

        </div>
      )
    }

    // Create a roof configuration object with the inputs needed such that
    // we can send it in
    let rf = {};
    for(let i = 0; i < ins.length; i++) {
      let vv = this.state["val_" + ins[i].name];
      rf[ins[i].name] = vv
    }

    const {sol, solLoading} = this.state
    const login = () => {
      const user = global.prompt('Username')
      const pass = global.prompt('Password')
      ReactGA.event({
        category: 'Login',
        action: 'login',
        label: 'user login',
        value: 'login'
      })
      this.props.Parse.User.logIn(user, pass, {
        success: (user) => {
          this.setState({user})
          this.updatePrices()
        },
        error: (user, error) => {
          window.alert(error.message)
          this.updatePrices()
          ReactGA.event({
            category: 'Login',
            action: 'login error',
            label: 'error ',
            value: error.message
          })
        }
      })
    };

    const logout = () => {
      this.props.Parse.User.logOut().then(yourOut => this.setState({ user : null }));
    };

    const user = this.props.Parse.User.current();

    return (
      <ReactHeight onHeightReady={this.onChangeHeight}>
      <div>
      <Step
      number={1}
      move={move}
      current={this.state.step}
      title={text.choose}
      login={login}
      logout={logout}
      user={user}>
      <small className="split">{text.select}</small>
      <Row>
      {types}
      </Row>
      </Step>

      <Step
      login={login}
      logout={logout}
      user={user}
      error={inputerror}
      number={2}
      move={move}
      current={this.state.step}
      title={text.dims}>
      <small className="split">{text.input + roofo.name}</small>
      <Row>
      <Col sm={8} md={7}>
      <center>
      <img
      src={"roofs/"+selected+"_measure.png"} alt="roof" className="measures"
      />
      </center>
      </Col>
      <Col sm={4} md={5}>
      {inputs}
      </Col>
      </Row>
      </Step>

      <Step
      login={login}
      logout={logout}
      user={user}
      error={utstickerror}
      number={3}
      move={move}
      current={this.state.step}
      title={text.chooseUtstick}>
      <Row>
      {utss}
      </Row>

      {utstickRenders}
      </Step>

      <Step
      login={login}
      logout={logout}
      user={user}
      number={4}
      move={move}
      current={this.state.step}
      title={text.cplate}
      nextEnabled={this.state.plate !== null}
      >
      {this.state.step === 4 && this.renderStep4()}
      </Step>
      {this.props.productOptions && this.state.step === 5 && (
        <Step
        number={5}
        title={text.pickProductOptions}
        move={move}
        current={this.state.step}
        >
        {solLoading && <Loading />}
        {!solLoading && sol && this.renderProductOptions()}
        </Step>
      )}
      <Step
      login={login}
      logout={logout}
      user={user}
      number={6}
      move={move}
      current={this.state.step}
      final={true}
      title={text.stepSolution}
      >
      {solLoading && <Loading />}
      {!solLoading && sol && (
        <Solution
        rabatt={this.state.rabatt}
        roof={layout.names[this.state.type]}
        ins={[ins].concat(utstickIns)}
        vals={this.state}
        plate={this.getplate().calcplate}
        price={this.state.prices}
        user={this.state.user}
        set={(s) => this.setState(s)}
        sol={sol}
        productOptions={this.getUsedProductOptions()}
        />
      )}
      </Step>
      </div>
      </ReactHeight>
    );
}
  getUsedProductOptions () {
    const productOptions = this.enhancheProductOptions()
    const {selectedProductOptions} = this.state
    if (!selectedProductOptions || !selectedProductOptions.length) {
      return null
    }
    return selectedProductOptions.filter(item => item.items && item.selected).map((item) => {
      const option = productOptions.find(({id}) => id === item.id)
      return {
        ...item,
        ...option
      }
    })
  }
  componentWillUpdateProductOptions (nextProps, nextState) {
    if (this.state.selectedProductOptions.length > 0) {
      const keys = ['family', 'plate', 'surface', 'type']
      let selectedProductOptionsDirty = false
      keys.forEach((key) => {
        if (this.state[key] !== nextState[key]) {
          selectedProductOptionsDirty = true
        }
      })
      selectedProductOptionsDirty && this.setState({selectedProductOptions: []})
    }
  }
  enhancheProductOptions () {
    const {productOptions} = this.props
    const {sol} = this.state
    const {calcplate: selectedPlate} = this.getplate()
    const totalArea = sol && sol.area ? sol.area / 1e1 : null
    const mone = sol && sol.mone || null
    const vindski = sol && sol.vindski || null
    var pipelength = 0
    const pipes = sol && sol.pipes || []
    for(var i = 0; i < pipes.length; i++) {
      pipelength += sol.pipes[i]*1
    }
    return [
      ...productOptions.map((item) => {
        const foundPlateProduct = selectedPlate.products && selectedPlate.products.find(plateProduct => plateProduct.nobb === item.nobb)

        return {
          ...item,
          defaultItems: foundPlateProduct && foundPlateProduct.number && isFinite(foundPlateProduct.number(totalArea,mone,vindski,pipelength)) ? Math.ceil(foundPlateProduct.number(totalArea, mone, vindski,pipelength)) : 0,
          id: item.nobb
        }
      })
    ]
  }
  renderProductOptions () {
    const {selectedProductOptions, type, sol} = this.state;

    // const fittings = selectedProductOptions.filter(({category}) => (category.toLowerCase() === 'tettebånd'));
    const fittings = [];
    const beslag = selectedProductOptions.filter(({category}) => (category.toLowerCase() === 'beslag'));
    const takrenner = selectedProductOptions.filter(({category}) => (category.toLowerCase() === 'takrenner'));
    const extras = selectedProductOptions.filter(({category}) => (category.toLowerCase() === 'tilbehør' || category === '' || !category));

    return (
      <FormGroup>
        <Row className='display-flex'>

          {(!selectedProductOptions||selectedProductOptions.length===0) && <p>Ingen ekstraprodukter tilgjennelig for dette taket</p>}



          {!!beslag.length && (<Col sm={12}>
            <h2>{text.c_fittings}</h2>
          </Col>)}
          {beslag.map((option, i ) => this.renderOption(option, i, selectedProductOptions))}

          {!!takrenner.length && (<Col sm={12}>
            <h2>{text.c_pipes}</h2>
          </Col>)}
          {takrenner.map((option, i ) => this.renderOption(option, i, selectedProductOptions))}

          {!!extras.length && (<Col sm={12}>
            <h2>{text.c_extras}</h2>
          </Col>)}
          {extras.map((option, i ) => this.renderOption(option, i, selectedProductOptions))}

        </Row>
      </FormGroup>)
  }


  renderOption(selected, id, selectedProductOptions) {
    return (
      <Col md={6} key={selected.nobb}>
        <div className="product-addon">
          <div className="product-addon-inner">
            <Row>
              <Col xs={9} className='col-9'>
                <button role='button' className={`selectionLabel text-muted ${selected.selected ? 'selectionLabelChecked' : 'selectionLabelUnChecked'}`}
                  onClick={() => this.setState({
                      selectedProductOptions: selectedProductOptions.map((item) => {

                        if (item.nobb === selected.nobb) {
                          return {
                            ...item,
                            selected: !selected.selected
                          }
                        }
                        return item;
                      })})}>{selected.name} - {selected.nobb}</button>
                <p>
                  <input
                    type="number"
                    name="gender"
                    id={`R${id}Value`}
                    value={selected.items}
                    className='form-control form-control-sm product-addon-input'


                    onChange={(event) => {
                        const newValue = Math.max(parseInt(event.target.value) || 0, 0);

                        return this.setState({
                          selectedProductOptions: selectedProductOptions.map((item) => {
                            if (item.nobb === selected.nobb) {
                              return {
                                ...item,
                                items: newValue
                              }
                            }
                            return item;
                          })
                        })
                    }}

                  />
                  <span>
                    {selected.defaultItems ? text.recommendedNumb : text.pickNumb}
                  </span>
                </p>
              </Col>
              <Col xs={3} className='col-3'>
                {selected.image && <p><img alt={selected.name} src={selected.image} className='img-fluid' /></p>}
              </Col>
            </Row>
          </div>
        </div>
      </Col>);
  }

  renderStep4 () {
    const {getOption, plates} = this.props
    const {pickerFamily, pickerProfile, pickerTreatment, pickerSurface} = this.state
    const placeholderImage = 'images/placeholder.png'
    const language = this.getLanguage()
    this.familyList = sortOn(unique(plates.map(item => item.props.family)), name => name)
    const availablePlatesForProfile = plates.filter(item => {
      if (pickerFamily) {
        return item.props.family === pickerFamily
      }
      return true
    })
    this.profileList = sortOn(availablePlatesForProfile.filter(item => !!item.props.profile).reduce((list, item) => {
      const name = item.props.profile.trim()
      if (!list.length || !list.find((listItem) => listItem.name === name)) {
        return [
          ...list,
          {
            name
          }
        ]
      }
      return list
    }, []), item => item.name)

    const availablePlatesForTreatment = availablePlatesForProfile.filter(item => {
      if (pickerProfile) {
        return item.props.profile === pickerProfile
      }
      return true
    })
    this.treatmentList = sortOn(availablePlatesForTreatment.filter(item => !!item.props.treatment).reduce((list, item) => {
      const name = item.props.treatment.trim()
      if (!list.length || !list.find((listItem) => listItem.name === name)) {
        return [
          ...list,
          {
            name
          }
        ]
      }
      return list
    }, []), item => item.name)

    const availablePlatesForSurface = availablePlatesForTreatment.filter(item => {
      if (pickerTreatment) {
        return item.props.treatment === pickerTreatment
      }
      return true
    })
    this.surfaceList = sortOn(availablePlatesForSurface.filter(item => !!item.props.surface).reduce((list, item) => {
      const name = item.props.surface.trim()
      if (!list.length || !list.find((listItem) => listItem.name === name)) {
        return [
          ...list,
          {
            name,
            image: item.props.image ? item.props.image : null,
            plate: item.props.name.trim()
          }
        ]
      }
      return list
    }, []), item => item.name)
    return (
      <div>
      <VisualNav title={text.product}>
      {this.familyList && this.familyList.map((item, i) => {
        const selected = pickerFamily === item
        return (
          <VisualNavItem
          key={i}
          title={item}
          image={getOption(`step4-${item}-image`) || placeholderImage}
          text={getOption(`step4-${item}-text-${language}`) || getOption(`step4-${item}-text`)}
          onClick={() => {
            this.setState({
              pickerFamily: selected ? null : item,
              pickerProfile: null,
              pickerTreatment: null,
              pickerSurface: null,
              pickerPlate: null
            })

            ReactGA.event({
              category: 'Select',
              action: 'Select family',
              label: 'Family ' + selected,
              value: selected
            })
          }}
          disabled={pickerFamily !== null && !selected}
          selected={selected}
          />
        )
      })}
      </VisualNav>
      {pickerFamily && (
        <VisualNav title={text.pickSurfaceTreatment}>
        {this.profileList && this.profileList.map((item, i) => {
          const selected = pickerProfile === item.name
          return (
            <VisualNavItem
            key={i}
            title={item.name}
            image={getOption(`step4-${item.name}-image`) || placeholderImage}
            text={getOption(`step4-${item.name}-text-${language}`) || getOption(`step4-${item.name}-text`)}
            onClick={() => {
              this.setState({
                pickerProfile: selected ? null : item.name,
                pickerTreatment: null,
                pickerSurface: null,
                pickerPlate: null
              })
            }}
            disabled={pickerProfile !== null && !selected}
            selected={selected}
            />
          )
        })}
        </VisualNav>
      )}
      {pickerFamily && pickerProfile && (
        <VisualNav title={text.pickPlateThickness}>
        {this.treatmentList && this.treatmentList.map((item, i) => {
          const selected = pickerTreatment === item.name
          return (
            <VisualNavItem
            key={i}
            title={item.name}
            image={false}
            text={getOption(`step4-${item.name}-text-${language}`) || getOption(`step4-${item.name}-text`)}
            onClick={() => {
              this.setState({
                pickerTreatment: selected ? null : item.name,
                pickerSurface: null,
                pickerPlate: null
              })
            }}
            disabled={pickerTreatment !== null && !selected}
            selected={selected}
            />
          )
        })}
        </VisualNav>
      )}

      {pickerFamily && pickerProfile && pickerTreatment && (
        <VisualNav title={text.pickColor}>
        {this.surfaceList && this.surfaceList.map((item, i) => {
          const selected = pickerSurface === item.name
          return (
            <VisualNavItem
            key={i}
            title={item.name}
            image={item.image || placeholderImage}
            onClick={() => {
              this.setState({
                pickerSurface: selected ? null : item.name,
                pickerPlate: selected ? null : item.plate,
              })
              ReactGA.event({
                category: 'Select',
                action: 'Select Surface',
                label: 'Surface ' + this.state.pickerSurface,
                value: this.state.pickerSurface
              })
            }}
            disabled={pickerSurface !== null && !selected}
            selected={selected}
            />
          )
        })}
        </VisualNav>
      )}
      </div>
    )
  }
}

const VisualNav = ({title, children}) => {
  return (
    <nav className='visual-nav'>
    <div className='row row-tight'>
    <div className='col-12'>
    <h2 className='visual-nav-title h4'>{title}</h2>
    </div>
    {children}
    </div>
    </nav>
  )
}

const VisualNavItem = ({title, image, text, onClick, disabled, selected}) => {
  return (
    <div className={`col-6 col-sm-4 col-md-3 visual-nav-item ${disabled ? 'visual-nav-item-disabled' : ''}`}>
    <button className='visual-nav-item-button' role='button' onClick={onClick}>
    {image && <img src={image} alt={title} className='visual-nav-item-image' />}
    <h3 className='visual-nav-item-title h5'>{selected && <span className='visual-nav-item-check' />}{title}</h3>
    <p>{text}</p>
    </button>
    </div>
  )
}

export default Main;



// WEBPACK FOOTER //
// ./Main.js